import { koComponent } from "../../../../ko-utils";
import { getServerSideData } from "../../../page";
import ItemBase from "./itemBase";
import generateTextForSupportedLanguages from "../../../../utils/generateTextForSupportedLanguages";
import { isFirstCardDynamic, getFirstCardUrlTemplateInfo } from '../../../../utils/tours';

class BtnItemTour extends ItemBase {
    constructor(params) {
        super(params, TourItemOpts);

        this.bindOpt('tourId', (tourId) => {
            const tour = this.allTours().filter(i => i.id == tourId)[0];

            if (tour) {
                this.root.name(generateTextForSupportedLanguages(tour.name));
            }
        });
    }
}

class TourItemOpts {
    constructor(data, parentParams) {
        if (!data) data = {};
        this.parentParams = parentParams;

        this.dynamicWarning = ko.observable(false);
        this.tourId = ko.observable(ko.unwrap(data.tourId));

        this.tourId.subscribe((v) => {
            this.evalWarning(v);
        });

        this.evalWarning(this.tourId());
    }

    //get item() {
    //    if (this.parentParams) {
    //        return this.parentParams.item;
    //    } else {
    //        return {};
    //    }
    //}

    evalWarning(tourId) {
        const allTours = getServerSideData('tours' || []);
        const tour = allTours.filter(i => i.id == tourId)[0];
        const urlFilter = this.parentParams && this.parentParams.item ? ko.unwrap(this.parentParams.item.urlFilter) : {};
        /** @type {Array} */
        const urlsRaw = urlFilter ? ko.unwrap(urlFilter.urls) : [];
        const urls = urlsRaw.map(i => ko.unwrap(i.parametrized));

        if (tour) {
            const isDynamic = isFirstCardDynamic(tour.descriptorObject) == 'yes';
            const cardInfo = getFirstCardUrlTemplateInfo(tour.descriptorObject);

            if (!isDynamic) {
                this.dynamicWarning(false);
            } else {
                this.dynamicWarning(cardInfo && urls.indexOf(cardInfo) === -1 && urls.indexOf(cardInfo.substring(1)) === -1);
            }
        } else {
            this.dynamicWarning(false);
        }
    }
}

export default koComponent('btn-item-tour', BtnItemTour);